import { memo } from "react";
import { Grid, Icon, Input, InputOnChangeData, Popup } from "semantic-ui-react";

type SubnetNameProps = {
  onChange: (
    event: React.FormEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => void;
  placeholder: string;
  value: string;
};

const SubnetName = ({ onChange, placeholder, value }: SubnetNameProps) => {
  return (
    <Grid.Row>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <h5>
          Subnet Name
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            <p>
              Desired name for subnet.
              <br /> Defaults to "&lt;network.name&gt;-subnet"
            </p>
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <Input
          placeholder={placeholder}
          value={value}
          className="select-box full"
          name="subnetName"
          onChange={onChange}
        />
      </Grid.Column>
    </Grid.Row>
  );
};

export default memo(SubnetName);
